import {Button, Form} from "react-bootstrap";
import {useState} from "react";
import Message from "../message";

function CsvCombiner() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;
    const [csv_combiner, setCsv_combiner] = useState("");
    const [status_csv_combiner, setStatus_csv_combiner] = useState("");

    const submit_csv_combiner = async () => {
        setStatus_csv_combiner("");
        console.log(csv_combiner.length);

        if (csv_combiner.length <= 0) {
            setStatus_csv_combiner("Upload some files!");
        } else {
            const formData = new FormData();

            for (let i = 0; i < csv_combiner.length; i++) {
                console.log(csv_combiner[i]);
                formData.append("files", csv_combiner[i]);
            }

            const requestOptions = {
                method: "POST",
                body: formData,
            };

            try {
                const csv_response = await fetch(
                    apiServer + "api/helper/combine_files",
                    requestOptions
                );
                const csv_combine_id = await csv_response.json();
                const csv_combine_status = csv_combine_id.detail
                    ? csv_combine_id.detail
                    : csv_combine_id;
                setStatus_csv_combiner(csv_combine_status);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{marginTop: "20px"}}>
            <Form.Control
                type="file"
                name="csv"
                id="csv"
                className="csvcls"
                onChange={(e) => setCsv_combiner(e.target.files)}
                multiple
            />
            {/*<input type="file" name="csv" id="csv" className="csvcls" onChange={(e) => setCsv_combiner(e.target.files)} multiple />*/}
            <Button
                variant="primary"
                style={{marginTop: "20px"}}
                onClick={() => submit_csv_combiner()}
            >
                Submit
            </Button>
            {Message(status_csv_combiner, setStatus_csv_combiner)}
        </div>
    );
}

export default CsvCombiner;
